import { InfoButton, Stack, Text, Tooltip } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { CABIN_UPGRADE } from '../../products';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const availabilityStatusStyles = css`
  align-items: center;
  display: flex;
  flex-direction: row;

  @media ${mediaQueries.small.only} {
    margin-top: 8px;
  }
`;
const CabinUpgradeAvailabilityStatus = _ref => {
  let {
    availabilityCardTexts,
    'data-testid': dataTestId,
    isSegmentAvailable
  } = _ref;
  const {
    availableStatus,
    statusTooltip,
    unavailableStatus
  } = availabilityCardTexts;
  const availabilityStatusText = isSegmentAvailable ? availableStatus : unavailableStatus;
  return /*#__PURE__*/_jsxs(Stack, {
    className: availabilityStatusStyles,
    "data-testid": dataTestId,
    spacing: 4,
    children: [!isSegmentAvailable && /*#__PURE__*/_jsx(Tooltip, {
      "aria-live": "polite",
      content: /*#__PURE__*/_jsx(Text, {
        children: statusTooltip
      }),
      "data-testid": `${CABIN_UPGRADE.name}-availability-status-tooltip`,
      title: "tooltip",
      trigger: "click",
      children: /*#__PURE__*/_jsx(InfoButton, {
        "data-testid": `${CABIN_UPGRADE.name}-availability-status-unavailable-icon`,
        label: "" // add aria label in accessibility jira AA-5663
      })
    }), /*#__PURE__*/_jsx(Text, {
      "aria-hidden": true,
      children: availabilityStatusText
    })]
  });
};
export default CabinUpgradeAvailabilityStatus;
//# sourceMappingURL=CabinUpgradeAvailabilityStatus.js.map